import script from "./PandoraCollapsible.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraCollapsible.vue?vue&type=script&setup=true&lang=js"

import "./PandoraCollapsible.vue?vue&type=style&index=0&id=12a00b2d&lang=css"

const __exports__ = script;

export default __exports__